import React from 'react'
import {EuiSpacer} from '@elastic/eui'

import ProductTable from '../../../components/Products/Compare/indoor-compare-table'

import BreadCrumbs from '../../../components/Layout/BreadCrumbs'
import NavButtons from '../../../components/Products/NavButtons'

import SEOHelmet from '../../../components/Layout/SEOHelmet'


const seodata = {
  title: 'Alle INSTAR Innenkamera Modelle Vergleichen',
  description: 'Alle INSTAR Innenkamera Modelle Vergleichen.',
  image: '/images/Search/QI_SearchThumb_SetupWizard.png',
  twitter: '/images/Search/QI_SearchThumb_SetupWizard.webp',
  locationEN: 'https://wiki.instar.com/en/Products/Compare/Indoor_Cameras/',
  locationDE: 'https://wiki.instar.com/de/Produkte/Vergleich/Innenkameras/',
  locationFR: 'https://wiki.instar.com/fr/Products/Compare/Indoor_Cameras/'
}


const IndoorCams = (props) => (
    <React.Fragment>

      <SEOHelmet
        title={seodata.title}
        description={seodata.description}
        image={seodata.image}
        location={props.location} />

      <BreadCrumbs
          locationBC={props.location}
          locationDE={props.location.pathname}
          locationEN='/en/Products/Compare/Indoor_Cameras/'
          locationFR='/fr/Products/Compare/Indoor_Cameras/'
          crumbLabel="Innenkameras" />
          
      <NavButtons />

      <h1>INSTAR Kamera Modelle Vergleiche</h1>

      <EuiSpacer />

      <ProductTable />
      
    </React.Fragment>
  )

export default IndoorCams